import React, { useMemo } from "react";
import {
  format,
  eachDayOfInterval,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  isSameDay,
} from "date-fns";

const EntriesUpdate = ({ companyOptions, allEntries, filterType }) => {
  const today = new Date();

  const dateRange = useMemo(() => {
    if (filterType === "week") {
      return eachDayOfInterval({
        start: startOfWeek(today),
        end: endOfWeek(today),
      });
    } else if (filterType === "month") {
      return eachDayOfInterval({
        start: startOfMonth(today),
        end: endOfMonth(today),
      });
    } else {
      return [today]; // Just today
    }
  }, [filterType]);

  const entriesByDateAndCompany = useMemo(() => {
    const map = new Map();

    allEntries.forEach((entry) => {
      const dateStr = new Date(entry.entry_date).toDateString();
      if (!map.has(dateStr)) map.set(dateStr, new Set());
      map.get(dateStr).add(entry.company_id);
    });

    return map;
  }, [allEntries]);

  const missingEntries = useMemo(() => {
    const results = {};

    dateRange.forEach((date) => {
      const dateStr = date.toDateString();
      const submittedCompanyIds =
        entriesByDateAndCompany.get(dateStr) || new Set();

      const missingCompanies = companyOptions
        .filter((c) => c.value !== "all" && !submittedCompanyIds.has(c.value))
        .map((c) => c.label);

      if (missingCompanies.length > 0) {
        results[dateStr] = missingCompanies;
      }
    });

    return results;
  }, [dateRange, companyOptions, entriesByDateAndCompany]);

  if (Object.keys(missingEntries).length === 0) {
    return (
      <div className="text-muted-foreground text-sm">
        All companies submitted entries 🎉
      </div>
    );
  }

  return (
    <div className=" my-5 border  p-2 ">
      <h3 className="text-lg font-semibold text-foreground py-2 ">
        Entries Update
      </h3>
      <div className="max-h-[400px] sm:max-h-[1050px] space-y-2 border  p-2 overflow-y-auto">
        {Object.entries(missingEntries).map(([dateStr, companies]) => (
          <div key={dateStr} className="border p-4 rounded bg-white shadow-sm">
            <h4 className="font-semibold text-sm mb-2">
              {format(new Date(dateStr), "MMMM dd, yyyy")}
            </h4>
            <ul className="list-disc list-inside text-red-500 text-sm">
              {companies.map((company) => (
                <li key={company}>{company} – No entries found</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EntriesUpdate;
